import React, { useState } from "react";
import "./gallery.css";

const Gallery = ({ title = "", description = "" }) => {
  const [galleryItems, setGalleryItems] = useState([
    {
      link: "https://images.pexels.com/photos/6685428/pexels-photo-6685428.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      img: "https://images.pexels.com/photos/6685428/pexels-photo-6685428.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      alt: "product",
    },
    {
      link: "https://images.pexels.com/photos/6685428/pexels-photo-6685428.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      img: "https://images.pexels.com/photos/6685428/pexels-photo-6685428.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      alt: "product",
    },
    {
      link: "https://images.pexels.com/photos/6685428/pexels-photo-6685428.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      img: "https://images.pexels.com/photos/6685428/pexels-photo-6685428.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      alt: "product",
    },
  ]);
  return (
    <div className="galleryWrapper">
      <h2>{title}</h2>
      <p>{description}</p>

      <div className="galleryContainer d-flex flex-row flex-wrap justify-content-center align-items-center gap-3 w-100">
        {galleryItems.map((gItem, i) => (
          <a key={`gallery-` + i} href={gItem.link}>
            <img
              src={`${gItem.img}`}
              alt={gItem.alt}
              className="gallery-item shadow-elevation-lightbg-medium"
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
